import { render, staticRenderFns } from "./ShowKt.vue?vue&type=template&id=4b0fe1d4&scoped=true&"
import script from "./ShowKt.vue?vue&type=script&lang=js&"
export * from "./ShowKt.vue?vue&type=script&lang=js&"
import style0 from "./ShowKt.vue?vue&type=style&index=0&id=4b0fe1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0fe1d4",
  null
  
)

component.options.__file = "ShowKt.vue"
export default component.exports